import { gql } from '@/__generated__';

const SET_DEVICE_MAIN_METRIC = gql(`#graphql
  mutation HomeAmaru_SetDeviceMainMetric($input: SetDeviceMainMetricInput!) {
    setDeviceMainMetric(input: $input) {
      metricField
      unit
      lastPoint
    }
  }
`);

export default SET_DEVICE_MAIN_METRIC;
